/* eslint-disable space-before-blocks */
const COMPANY_SECRETARY_FOREIGN_RESIDENT = [
  {
    label: "Passport Photo(On A White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "Passport(BIOS PAGE)", name: "passportBIOS", optional: true },
  { label: "Current Work Permit", name: "workPermit", optional: true },
  { label: "KRA Certificate", name: "KRACert" },
  { label: "Foreigner Certificate", name: "foreignerCert" },
  { label: "ICPSK Practicing Certificate", name: "practicingCert" },
];

const REGULATED_ARTICLES = [{ label: "Choose File", name: "Choose File" }];
const SPECIAL_INSTRUCTIONS = [{ label: "Choose File", name: "Choose File" }];

const COMPANY_SECRETARY_KENYAN = [
  {
    label: "Passport Photo(On A White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "National Id", name: "nationalID" },
  { label: "KRA PIN Certificate", name: "KRACert" },
  { label: "ICPSK Practicing Certificate", name: "practicingCert" },
];

const COMPANY_SECRETARY_LOCAL_COMPANY = [
  { label: "Certificate Of Incorporation", name: "certOfIncorporation" },
  {
    label: "Certificate Of Incumbency",
    name: "certOfIncumbency",
    optional: true,
  },
  { label: "KRA PIN Certificate", name: "KRAPIN" },
  {
    label: " ICPSK Practicing Certificate For Lead Partner",
    name: "leadPartnerCertificate",
  },
];

const FOREIGNER = [
  {
    label: "Passport Photo(On A White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png ",
  },
  { label: "Passport(BIOS PAGE)", name: "passportBIOS" },
];

const FOREIGN_COMPANY = [
  { label: "Certificate Of Incorporation", name: "certOfIncorporation" },
  {
    label: "Memorandum and Articles Of Association",
    name: "articlesOfAssociation",
  },
  {
    label: "Certificate Of Incumbency",
    name: "certOfIncumbency",
    optional: true,
  },
];

const FOREIGN_RESIDENT = [
  {
    label: "Upload Passport Photo(On White-Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "Foreigner Certificate", name: "foreignerCert" },
  { label: "KRA Certificate", name: "KRACert" },
  { label: "Current Work Permit", name: "workPermit", optional: true },
];

const KENYAN_CITIZEN = [
  {
    label: "Upload Passport Photo(On White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "National Id", name: "nationalID" },
  { label: "KRA Certificate", name: "KRACert" },
];

const MINOR = [
  {
    label: "Passport Photo(On White Background)",
    name: "passportPhoto",
    accept: "image/jpeg, image/jpg, image/png",
  },
  { label: "Birth Certificate", name: "birthCertificate" },
];

const LOCAL_COMPANY = [
  { label: "Certificate Of Incorporation", name: "certOfIncorporation" },
  { label: "KRA Certificate", name: "KRACert" },
  {
    label: "Memorandum And Articles Of Association",
    name: "articlesOfAssociation",
  },
  {
    label: "Official Search Results(FORM CR12)",
    name: "searchResults",
    optional: true,
  },
  {
    label: "Certificate Of Incumbency",
    name: "certOfIncumbency",
    optional: true,
  },
];

const RESIGNATION_OFFICIAL = [
  {
    label: "Letter of Resignation | Template",
    name: "letterOfResignation",
    accept: "image/jpeg, image/jpg, image/png",
  },
  {
    label: "Statutory Declaration | Template",
    name: "statutoryDeclaration",
    accept: "image/jpeg, image/jpg, image/png",
    optional: true,
  },
  {
    label: "Extract of Board Resolution | Template",
    name: "extractOfBoardResolution",
    accept: "image/jpeg, image/jpg, image/png",
    optional: true,
  },
];

const APPOINTMENT_OFFICIAL = [
  {
    label: "Consent to Act as an Authorized Person",
    name: "consentOfAuthorizedPerson",
    accept: "image/jpeg, image/jpg, image/png",
  },
  {
    label: "Form CR6",
    name: "Cr6Form",
    accept: "image/jpeg, image/jpg, image/png",
    // optional: true,
  },
  {
    label: "Form CR8",
    name: "Cr8Form",
    accept: "image/jpeg, image/jpg, image/png",
    // optional: true,
  },
];

const OTHER = [{ label: "Gazette Notice", name: "gazetteNotice" }];

const getEstateDocumentData = (isEstateDistributed) => {
  let estateDocuments = [
    { label: "Copy of ID Card", name: "copyOfIDCard" },
    { label: "Copy of Death Certificate", name: "copyOfDeathCertificate" },
  ];
  if (isEstateDistributed === "Yes") {
    estateDocuments = [
      ...estateDocuments,
      {
        label: "Certificate of Confirmation of Probate",
        name: "certificateOfConfirmationOfProbate",
      },
      {
        label: "Copy of Will/Schedule of Distribution)",
        name: "copyOfWill/ScheduleOfDistribution)",
      },
    ];
  }
  return estateDocuments;
};

const getOnboardingDocuments = (idType) => {
  let documentData = [];
  switch (idType) {
    case "Kenyan Citizen":
      documentData = [
        {
          label: "Upload Passport Photo(On White Background)",
          name: "passportPhoto",
          accept: "image/jpeg, image/jpg, image/png",
        },
        { label: "National Id", name: "nationalID" },
      ];
      break;
    case "Foreign Resident":
      documentData = [
        {
          label: "Upload Passport Photo(On White-Background)",
          name: "passportPhoto",
          accept: "image/jpeg, image/jpg, image/png",
        },
        { label: "Foreigner Certificate", name: "foreignerCert" },
      ];
      break;
    case "Foreigner":
      documentData = FOREIGNER;
      break;
    default:
      documentData = [];
  }
  return documentData;
};

const getDocumentData = (idType) => {
  let documentData = [];
  switch (idType) {
    case "Kenyan Citizen":
      documentData = KENYAN_CITIZEN;
      break;
    case "Foreign Resident":
      documentData = FOREIGN_RESIDENT;
      break;
    case "Foreigner":
      documentData = FOREIGNER;
      break;
    case "Local Company":
      documentData = LOCAL_COMPANY;
      break;
    case "Other e.g Parastatals":
      documentData = OTHER;
      break;
    case "Foreign Company":
      documentData = FOREIGN_COMPANY;
      break;
    case "Minor":
      documentData = MINOR;
      break;
    default:
      documentData = [];
  }
  return documentData;
};

export const getChangeOfParticularsData = (processType, idType) => {
  let documentData = [];
  switch (processType) {
    case "idTypeChange":
      documentData = getDocumentData(idType); // Use getDocumentData to fetch documents for the new ID type
      break;
    case "nameChangeIndividual":
      documentData = [
        {
          label: "Upload Deed Poll",
          name: "deedPoll",
          accept: "application/pdf",
        },
      ];
      break;
    case "nameChangeCorporate":
      documentData = [
        {
          label: "Upload Certificate of Change of Name",
          name: "certificateOfChangeOfName",
          accept: "application/pdf",
        },
      ];
      break;
    case "contactChangeIndividual":
      documentData = [
        {
          label: "Upload Statutory Declaration",
          name: "statutoryDeclaration",
          accept: "application/pdf",
        },
      ];
      break;
    default:
      // No action needed, documentData remains as []
      break;
  }
  return documentData;
};

const getChangedDocumentsModuleData = (processType, idType = "") => {
  let documentData = [];
  switch (processType) {
    case "officials":
      documentData = getDocumentData(idType);
      break;

    case "shareTransferChangeDocuments":
      documentData = [
        {
          label: "Share Transfer Form",
          name: "shareTransferForm",
          accept: "application/pdf",
        },
        {
          label: "Ardhisasa Invoice Receipt",
          name: "ardhisasaInvoiceReceipt",
          accept: "application/pdf",
        },
        {
          label: "Proof of Payment of Stamp Duty",
          name: "proofOfPaymentOfStampDuty",
          accept: "application/pdf",
        },
      ];
      break;

    case "appointmentChangeDocuments":
      documentData = [
        {
          label: "Consent to Act",
          name: "consentToAct",
          accept: "application/pdf",
        },
        {
          label: "Appointment Letter",
          name: "appointmentLetter",
          accept: "application/pdf",
        },
      ];
      break;

    case "changeOfParticularsChangeDocuments":
      documentData = [
        {
          label: "Statutory Declaration",
          name: "statutoryDeclaration",
          accept: "application/pdf",
        },
      ];
      break;

    case "cessationChangeDocuments":
      documentData = [
        {
          label: "Letter of Resignation",
          name: "letterOfResignation",
          accept: "application/pdf",
        },
        {
          label: "Statutory Declaration",
          name: "statutoryDeclaration",
          accept: "application/pdf",
        },
      ];
      break;

    case "signedUploadChangeDocument":
      documentData = [
        {
          label: "Consent to Act",
          name: "signedUploadChangeDocument",
          accept: "application/pdf",
        },
      ];
      break;

    case "signedDirectorApprovalDocs":
      documentData = [
        {
          label: "Signed Board Resolutions",
          name: "signedDirectorApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;

    case "signedShareholderApprovalDocs":
      documentData = [
        {
          label: "Signed Shareholder Resolutions",
          name: "signedShareholderApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;

    case "changeDocuments":
      documentData = [
        {
          label: "Consent to Act",
          name: "consentToAct",
          accept: "application/pdf",
        },
      ];
      break;

    case "directorApprovalDocs":
      documentData = [
        {
          label: "Board Resolutions",
          name: "directorApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;

    case "shareholderApprovalDocs":
      documentData = [
        {
          label: "Shareholder Resolutions",
          name: "shareholderApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;

    case "courtOrderApprovalDocs":
      documentData = [
        {
          label: "Court Order",
          name: "courtOrderApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;

    case "gazetteApprovalDocs":
      documentData = [
        {
          label: "Gazette Notice",
          name: "gazetteApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;

    case "creditorApprovalDocs":
      documentData = [
        {
          label: "Creditor Resolutions",
          name: "creditorApprovalDocs",
          accept: "application/pdf",
        },
      ];
      break;

    case "ownConsentResolutionType":
      documentData = [
        {
          label: "Consent Resolution Letter",
          name: "consentResolutionType",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "platformConsentResolutionType":
      documentData = [
        {
          label: "Consent Resolution Letter",
          name: "consentResolutionType",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "ownResignationLetterTemplate":
      documentData = [
        {
          label: "Upload Your Own Resignation Letter",
          name: "ownResignationLetterTemplate",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "ownStatutoryDeclarationTemplate":
      documentData = [
        {
          label: "Upload Your Own Statutory Declaration Template",
          name: "ownStatutoryDeclarationTemplate",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "appointingOfficialSignedDocuments":
      documentData = [
        {
          label: "Consent to Act Document",
          name: "consentFormForAuthorizedPerson",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "appointmentLetter":
      documentData = [
        {
          label: "Notice of Appointment Letter",
          name: "appointmentLetter",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "directorApprovalSignedDocuments":
      documentData = [
        {
          label: "Signed Board Resolutions Approving the Change(s)",
          name: "ownConsentResolutionForDirectorApproval",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "shareholderApprovalSignedDocuments":
      documentData = [
        {
          label: "Signed Shareholder Resolutions Approving the Change(s)",
          name: "ownConsentResolutionForShareholderApproval",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "gazetteApprovalSignedDocuments":
      documentData = [
        {
          label: "Signed Gazette Notice Approving the Change(s)",
          name: "ownConsentResolutionForGazetteApproval",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "courtOrderApprovalSignedDocuments":
      documentData = [
        {
          label: "Court Order Approving the Change(s)",
          name: "ownConsentResolutionForCourtOrderApproval",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "creditorsApprovalSignedDocuments":
      documentData = [
        {
          label: "Signed Creditors Resolutions Approving the Change(s)",
          name: "ownConsentResolutionForCreditorsApproval",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "ownStatutoryTemplateForDirectorApproval":
      documentData = [
        {
          label: "Upload Your Own Statutory Declaration Template",
          name: "ownStatutoryDeclarationTemplate",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "ownStatutoryTemplateForShareholderApproval":
      documentData = [
        {
          label: "Upload Your Own Statutory Declaration Template",
          name: "ownStatutoryShareholderTemplate",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "deedPoll":
      documentData = [
        {
          label: "Upload Deed Poll",
          name: "deedPoll",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "certificateOfChnageOfName":
      documentData = [
        {
          label: "Upload Certificate of Change of Name",
          name: "certificateOfChangeOfName",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "statutoryDeclaration":
      documentData = [
        {
          label: "Upload Statutory Declaration",
          name: "statutoryDeclaration",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "letterOfResignation":
      documentData = [
        {
          label: "Letter of Resignation",
          name: "letterOfResignation",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "noticeOfRemoval":
      documentData = [
        {
          label: "Notice of Removal",
          name: "noticeOfRemoval",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "shareholdersSpecialNotice":
      documentData = [
        {
          label: "Shareholders Special Notice",
          name: "shareholdersSpecialNotice",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "deathCertificate":
      documentData = [
        {
          label: "Death Certificate",
          name: "deathCertificate",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "insolvencyOrder":
      documentData = [
        {
          label: "Insolvency Order",
          name: "insolvencyOrder",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "medicalReport":
      documentData = [
        {
          label: "Medical Report",
          name: "medicalReport",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "courtOrder":
      documentData = [
        {
          label: "Court Order",
          name: "courtOrder",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "consentToAct":
      documentData = [
        {
          label: "Consent to Act",
          name: "consentToAct",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    case "approvedChangesDocuments":
      documentData = [
        {
          label: "Consent to Act Document",
          name: "consentFormForAuthorizedPerson",
          accept: "application/pdf,.docx",
        },
      ];
      break;

    default:
      documentData = [];
  }
  return documentData;
};

const getCompanySecretaryDocumentData = (idType) => {
  let documentData = [];
  switch (idType) {
    case "Kenyan Citizen":
      documentData = COMPANY_SECRETARY_KENYAN;
      break;
    case "Foreign Resident":
      documentData = COMPANY_SECRETARY_FOREIGN_RESIDENT;
      break;
    case "Other":
      documentData = OTHER;
      break;
    case "Local Company":
      documentData = COMPANY_SECRETARY_LOCAL_COMPANY;
      break;
    default:
      documentData = [];
  }
  return documentData;
};

const getBusinessDocumentData = () => {
  return [
    { label: "Form CR1", name: "formCR1", accept: "application/pdf" },
    { label: "Form CR2", name: "formCR2", accept: "application/pdf" },
    {
      label: "Statement of Nominal Capital",
      name: "statementOfNominalCapital",
      accept: "application/pdf",
    },
    {
      label: "Articles of Association",
      name: "articlesOfAssociation",
      accept: "application/pdf",
    },
    { label: "Form CR8", name: "formCR8", accept: "application/pdf" },
    { label: "Form CR10", name: "formCR10", accept: "application/pdf" },
    { label: "Form CR12", name: "formCR12", accept: "application/pdf" },
    {
      label: "Form BOF1",
      name: "formBOF1",
      accept: "application/pdf",
      optional: true,
    },
  ];
};

const getManageCompanyUploadDocuments = (processType) => {
  let documentData = [];
  switch (processType) {
    case "changeDocuments":
      documentData = [
        {
          label: "Consent To Act For Authorized Person",
          name: "consentToAct",
          accept: "application/pdf",
        },
      ];
      break;
    case "directorApproval":
      documentData = [
        {
          label: "Board Resolution",
          name: "BoardResolution",
          accept: "application/pdf",
        },
      ];
      break;
    default:
      documentData = [];
  }
  return documentData;
};

export {
  COMPANY_SECRETARY_FOREIGN_RESIDENT,
  COMPANY_SECRETARY_KENYAN,
  COMPANY_SECRETARY_LOCAL_COMPANY,
  FOREIGNER,
  FOREIGN_COMPANY,
  FOREIGN_RESIDENT,
  KENYAN_CITIZEN,
  MINOR,
  LOCAL_COMPANY,
  OTHER,
  REGULATED_ARTICLES,
  SPECIAL_INSTRUCTIONS,
  RESIGNATION_OFFICIAL,
  APPOINTMENT_OFFICIAL,
  getDocumentData,
  getOnboardingDocuments,
  getEstateDocumentData,
  getCompanySecretaryDocumentData,
  getBusinessDocumentData,
  getChangedDocumentsModuleData,
  getManageCompanyUploadDocuments,
};
